import React, { useEffect, useState, useMemo } from "react";
import { Outlet, Link } from "react-router-dom";
import { Form, Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { BiCategory, BiFilterAlt } from "react-icons/bi";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';


function Brand() {
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [Eshow, setEShow] = useState(false);
  const [statusShow, setStatusShow] = useState();
  const [newUpdateStatus, setNewUpdateStatus] = useState();
  const [errors, setErrors] = useState(false);
  const [toastText, setToastText] = useState('');
  const [brand, setBrand] = useState();
  const [editBrand, setEditBrand] = useState();
  const [brandList, setBrandList] = useState([]);
  const [dshow, setDShow] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  // Pagination & Search states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const filteredBrands = useMemo(() => {
    if (!Array.isArray(brandList)) return [];
    if (!searchText.trim()) return brandList;
    const q = searchText.trim().toLowerCase();
    return brandList.filter((b) => {
      const name = (b.name || "").toLowerCase();
      const id = String(b.id || "").toLowerCase();
      return name.includes(q) || id.includes(q);
    });
  }, [brandList, searchText]);

  const totalItems = filteredBrands.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedBrands = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredBrands.slice(startIndex, endIndex);
  }, [filteredBrands, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const [brandPreview, setBrandPreview] = useState({
    image: '',
    banner: ''
  });
  const [newBrand, setNewBrand] = useState({
    id: '',
    name: '',
    image: '',
    banner: '',
    status: '',
  });
  const [brandSelected, setBrandSelected] = useState({
    id: '',
    image: '',
    heading: '',
    banner: '',
    status: '',
  });
  const handleOpen = () => {
    setShow(true);
    setNewBrand({ id: '', name: '', status: '' });
    setErrors(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  const editCall = (item) => {
    setEditBrand(item);
    setErrors(false);
    setEShow(true);
  };
  console.log(editBrand, 'check editBrand');
  const handleCloseEdit = () => {
    setEShow(false);
  };

  const handleStatus = (item) => {
    setStatusShow(true);
    setNewUpdateStatus(item);
  }
  const handleStatusClose = () => {
    setStatusShow(false);
  }

  function handlePreview(e) {
    setBrandPreview({ ...brandPreview, image: URL.createObjectURL(e.target.files[0]) });
    setNewBrand({ ...newBrand, image: e.target.files[0] });
    setEditBrand({ ...editBrand, image: e.target.files[0] });
    console.log(newBrand, 'newBrand');
  }
  function handleBannerPreview(e) {
    setBrandPreview({ ...brandPreview, banner: URL.createObjectURL(e.target.files[0]) });
    setNewBrand({ ...newBrand, banner: e.target.files[0] });
    setEditBrand({ ...editBrand, banner: e.target.files[0] });
    console.log(newBrand, 'newBrand');
  }

  const fetchbrandList = async () => {
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/list`);
      if (response.data?.success && response.data?.data) {
        let list = response.data.data.list || [];
        const pagination = response.data.data.pagination;
        if (pagination && pagination.total_pages > 1 && list.length < pagination.total_data) {
          const pagePromises = [];
          for (let p = 2; p <= pagination.total_pages; p++) {
            pagePromises.push(axios.post(`/admin/master/brand/list?page=${p}`));
          }
          const extraResponses = await Promise.all(pagePromises);
          extraResponses.forEach(res => {
            if (res.data?.success && res.data?.data?.list) {
              list = list.concat(res.data.data.list);
            }
          });
        }
        setBrandList(list);
      }
    } catch (err) {
      console.log('brand list error', err.response);
    } finally {
      setLoader(false);
    }
  };

  const addBrandMaster = async () => {
    if (!newBrand?.name?.trim()) {
      setErrors('Brand Name is Missing');
      return;
    }
    setLoader(true);
    const formData = new FormData();
    formData.append("name", newBrand.name);

    const token = Cookies.get('s_l');
    const newToken = decrpt(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    try {
      const response = await axios.post(`/admin/master/brand/save`, formData);
      if (response.data.success) {
        setShow(false);
        setNewBrand({ id: '', name: '', status: '' });
        fetchbrandList();
        setToastText("Brand Added");
        toast.success("Brand Added Successfully", { hideProgressBar: true });
      }
    } catch (err) {
      console.log('brand add error', err);
      toast.error(err.response?.data?.message || "Sorry Something Went Wrong", { hideProgressBar: true });
      setErrors('Brand Name is Missing');
    } finally {
      setLoader(false);
    }
  }

  const updatebrand = async () => {
    if (!editBrand?.name?.trim()) {
      setErrors('Brand Name is Missing');
      return;
    }
    setLoader(true);
    const formData = new FormData();
    formData.append("id", editBrand.id);
    formData.append("name", editBrand.name);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/save`, formData);
      if (response.data.success) {
        setEShow(false);
        fetchbrandList();
        setToastText("Brand Name Updated");
        toast.success("Brand Name Updated Successfully", { hideProgressBar: true });
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Failed to update brand", { hideProgressBar: true });
    } finally {
      setLoader(false);
    }
  }

  const brandStatus = async () => {
    if (!newUpdateStatus) return;
    setLoader(true);
    try {
      const newstatus = newUpdateStatus.status == 1 ? 2 : 1;
      const data = {
        id: newUpdateStatus.id,
        status: newstatus
      };
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/status`, data);
      if (response.data?.success) {
        setBrandList(prev => prev.map(b => b.id === newUpdateStatus.id ? { ...b, status: newstatus } : b));
        setStatusShow(false);
        toast.success("Brand Status Updated Successfully", { hideProgressBar: true });
      }
    } catch (error) {
      console.log(error, 'error');
      toast.error(error.response?.data?.message || "Something went wrong", { hideProgressBar: true });
    } finally {
      setLoader(false);
    }
  };

  const handleCloseDelete = () => {
    setDShow(false);
    setDeleteItem(null);
  };

  const handleDelete = (item) => {
    setDeleteItem(item);
    setDShow(true);
  };

  const confirmDeleteBrand = async () => {
    if (!deleteItem) return;
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/delete`, { id: deleteItem.id });
      if (response.data?.success) {
        setBrandList(prev => prev.filter(b => b.id !== deleteItem.id));
        toast.success("Brand Deleted Successfully", { hideProgressBar: true });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete brand", { hideProgressBar: true });
    } finally {
      setDShow(false);
      setDeleteItem(null);
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchbrandList();
  }, []);
  return (
    <div className="main-content">
      {loader ?
        <Loader />
        :
        <>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme={'colored'} />

          {/* New User Registration */}
          <div className="section">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h5><BiCategory className="me-1" />All Brands</h5>
                </div>
                <div className="card p-2 mt-3">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0">You have {totalItems} Brands</h5>
                      <Button onClick={() => handleOpen()} className="badge btn-xs pt-1">Add New Brands</Button>
                    </div>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Brand Name..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Brand</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          paginatedBrands && paginatedBrands.length > 0 ? paginatedBrands.map((item, index) => {
                            return (

                              <tr key={index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td>{item.name}</td>
                                <td className="text-center">
                                  {item && item.status == 1 ?
                                    <Badge bg="success">Enable</Badge> :
                                    <Badge bg="danger">Disable</Badge>}
                                </td>
                                <td className="text-center">
                                  <button onClick={() => editCall(item)} className='btn btn-xs btn-primary text-white'>Edit</button> &nbsp;
                                  {item && item.status == 1 ?
                                    <button type="button" onClick={() => handleStatus(item)} className='btn btn-xs btn-secondary text-white'>Make Disable</button> :
                                    <button type="button" onClick={() => handleStatus(item)} className='btn btn-xs btn-success text-white'>Make Enable</button>} &nbsp;
                                  <button type="button" onClick={() => handleDelete(item)} className='btn btn-xs btn-danger text-white'>Delete</button>
                                </td>
                              </tr>
                            )
                          }) :
                            <tr>
                              <td colSpan={4} className="text-center fst-italic text-danger">No brands found</td>
                            </tr>
                        }
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div className="flex items-center justify-between mt-4 px-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1rem', padding: '0 0.5rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>Show</span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{ padding: '0.25rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', outline: 'none', background: '#fff' }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>entries</span>
                        </div>

                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span className="text-sm font-medium px-2 text-gray-700" style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}>
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Add Brand Modal */}
                  <Modal size="md" show={show} onHide={handleClose}>
                    <Modal.Header className="py-1" closeButton>
                      <Modal.Title>Add Brand</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Brand Name</Form.Label>
                          <Form.Control size="sm" type="text"
                            placeholder="Enter Brand Name"
                            value={newBrand?.name || ''}
                            onChange={e => setNewBrand({ ...newBrand, name: e.target.value })}
                          />
                          {errors && errors ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors}</p> : ''}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleClose()} className="btn btn-light btn-sm">Close</button>
                      <button type="button" onClick={() => addBrandMaster()} className="btn btn-primary btn-sm">Save Changes</button>
                    </Modal.Footer>
                  </Modal>

                  {/* Edit Brand Modal */}
                  <Modal size="md" show={Eshow} onHide={handleCloseEdit}>
                    <Modal.Header closeButton>
                      <Modal.Title>Edit Brand</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Brand Name</Form.Label>
                          <Form.Control size="sm" type="text" placeholder="Enter Brand Name"
                            value={editBrand?.name || ''}
                            onChange={e => setEditBrand({ ...editBrand, name: e.target.value })}
                          />
                          {errors && errors ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors}</p> : ''}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleCloseEdit()} className="btn btn-light btn-sm">Close</button>
                      <button onClick={() => updatebrand()} className="btn btn-primary btn-sm">Save Changes</button>
                    </Modal.Footer>
                  </Modal>

                  <Modal size="md" show={statusShow} centered onHide={handleStatusClose}>
                    <Modal.Header className="py-1" closeButton>
                      <Modal.Title className="h6">Do you want to  {
                        newUpdateStatus && newUpdateStatus.status == 1 ? 'Disable' : 'Enable'
                      } Brand ? <br /><span className="text-danger text-capitalize fw-bold">{newUpdateStatus && newUpdateStatus.name}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Footer className="p-1 justify-content-start">
                      <button onClick={() => handleStatusClose()} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={() => brandStatus()} >
                        {newUpdateStatus && newUpdateStatus.status == 1 ? 'Make Disable' : 'Make Enable'}
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Delete Brand Modal */}
                  <Modal size="md" show={dshow} onHide={handleCloseDelete} centered>
                    <Modal.Header closeButton>
                      <Modal.Title className="h6 fw-bolder">Delete Brand</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete brand <strong>{deleteItem?.name}</strong>?
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-end">
                      <button onClick={handleCloseDelete} className="btn btn-light btn-sm">
                        Cancel
                      </button>
                      <button onClick={confirmDeleteBrand} className="btn btn-danger btn-sm">
                        Delete
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}

export default Brand;
